<style lang="scss" scoped>
.notice {
    &-container {
        width: 440px;
        line-height: normal;
    }

    &-list {
        max-height: 400px;
        overflow: auto;
        padding-bottom: 32px;
    }

    &-none {
        text-align: center;
        line-height: 32px;
        margin-bottom: 16px;
        font-size: 13px;
    }

    &-item {
        width: 100%;
        padding: 12px 20px;
        border-bottom: 1px solid #e8eaec;
        cursor: pointer;
        transition: background-color 0.2s ease-in-out;
        text-align: left;

        &-unread {
            background-color: #f8f8f9;
        }

        &:hover {
            background-color: #f0faff;
        }

        &:last-child {
            border: none;
        }

        &-title {
            margin-bottom: 4px;

            h4 {
                font-size: 13px;
                font-weight: 400;
                line-height: 22px;
                color: #515a6e;
                white-space: normal;
                word-break: break-all;
            }

            a {
                color: inherit;
            }
        }
        &-unread h4 {
            font-weight: 600;
        }

        &-desc {
            font-size: 12px;
            color: #808695;
            justify-content: space-between;
            width: 100%;
            span {
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                word-break: break-all;
            }
        }

        &-tag {
            float: right;
            margin-top: -2px;
        }
    }

    &-tab-loading {
        &-item {
            border-top: 1px solid #e8eaec;
            text-align: center;
            font-size: 14px;
            padding: 6px 0;
            color: #515a6e;
            -webkit-transition: color 0.2s ease-in-out;
            transition: color 0.2s ease-in-out;
        }

        &-more {
            cursor: pointer;
            color: #2d8cf0;
        }

        &-all {
            color: #c5c8ce;
        }

        &-progress {
            color: #c5c8ce;
            cursor: not-allowed;
        }

        &-icon {
            position: relative;
            top: 5px;
            right: 3px;
        }
    }

    &-footer {
        border-top: 1px solid #e8eaec;
        background-color: #fff;
        // text-align: center;
        font-size: 14px;
        // cursor: pointer;
        padding: 6px 0 2px;
        color: #515a6e;
        transition: color 0.2s ease-in-out;
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        z-index: 10;
        display: flex;
        justify-content: center;
        & > * {
            cursor: pointer;
            margin: 0 5px;
        }
    }
    &-loading {
        cursor: default;
        & > i {
            height: 18px;
            width: 18px;
            transform: center center;
            animation: notice-loading 1s linear infinite;
            color: #2d8cf0;
            vertical-align: bottom;
        }
    }
    @keyframes notice-loading {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(360deg);
        }
    }
}
</style>
<style>
.nav-notice .vview-badge-label {
    line-height: 1;
}

.nav-notice .ivu-tabs-nav-container {
    padding-left: 12px;
}
.nav-notice .ivu-tabs-nav .ivu-tabs-tab {
    min-width: 90px;
}
.nav-notice .ivu-tabs-nav .ivu-tabs-tab:last-child {
    margin-right: 0;
}
.nav-notice .ivu-tabs-tabpane {
    position: relative;
}
</style>

<template>
    <aside class="notice nav-notice">
        <Dropdown
            @on-visible-change="getRecentList"
            ref="notice"
            trigger="click"
        >
            <Badge
                :count="getAllTotalCount"
                overflow-count="99"
                :show-zero="false"
            >
                <vIcon size="26" type="ios-notifications-outline"></vIcon>
            </Badge>
            <DropdownMenu slot="list">
                <div @click.stop class="notice-container">
                    <div class="notice-tabs">
                        <Tabs :value="name">
                            <TabPane
                                :label="
                                    $t('ucadm.notice.inform', {
                                        defaultValue: '通知',
                                    }) +
                                    '(' +
                                    getNotifyTotalCount +
                                    ')'
                                "
                                name="1"
                            >
                                <div class="notice-list">
                                    <ul class="notice-list-content">
                                        <template
                                            v-for="(
                                                items, key
                                            ) in noticeRecentLists"
                                        >
                                            <li
                                                :class="getNoticeClasses(item)"
                                                :key="'' + index + key"
                                                v-for="(item, index) in items"
                                            >
                                                <div
                                                    class="ivu-row-flex ivu-row-flex-middle"
                                                >
                                                    <div
                                                        class="ivu-col ivu-col-span-4"
                                                    >
                                                        <Avatar
                                                            circle
                                                            v-bind="
                                                                noticeType[key]
                                                            "
                                                        />
                                                    </div>
                                                    <a
                                                        @click="
                                                            handleNoticeModal(
                                                                item,
                                                            )
                                                        "
                                                    >
                                                        <div
                                                            class="notice-item-content ivu-col ivu-col-span-20"
                                                        >
                                                            <div
                                                                class="notice-item-title"
                                                            >
                                                                <h4>
                                                                    {{
                                                                        item.title
                                                                    }}
                                                                </h4>
                                                            </div>
                                                            <div
                                                                class="notice-item-desc"
                                                            >
                                                                {{
                                                                    item.notifyReceiveAt
                                                                }}
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </li>
                                        </template>
                                    </ul>
                                </div>
                                <div class="notice-footer">
                                    <a @click="readAllNotice">全部标为已读</a>
                                    <a
                                        href="/home/notice/list"
                                        target="_blank"
                                        >{{
                                            $t("ucadm.notice.readmore", {
                                                defaultValue: "查看更多",
                                            })
                                        }}</a
                                    >
                                    <a
                                        v-if="!noticeLoading"
                                        @click="getRecentNoticeList"
                                        >{{
                                            $t("global.common.refresh", {
                                                defaultValue: "刷新",
                                            })
                                        }}</a
                                    >
                                    <a v-else class="notice-loading"
                                        ><vIcon
                                            size="18"
                                            type="ios-loading"
                                        ></vIcon>
                                        {{
                                            $t("ucadm.notice.isrefreshing", {
                                                defaultValue: "正在刷新",
                                            })
                                        }}</a
                                    >
                                </div>
                            </TabPane>
                            <TabPane
                                :label="
                                    $t('ucadm.notice.task', {
                                        defaultValue: '任务',
                                    })
                                "
                                name="2"
                            >
                                <div class="notice-list">
                                    <ul class="notice-list-content">
                                        <li
                                            v-for="(
                                                item, index
                                            ) in noticeTaskLists"
                                            :key="index"
                                            class="notice-item"
                                        >
                                            <div
                                                class="ivu-row-flex ivu-row-flex-middle"
                                            >
                                                <div
                                                    class="notice-item-content ivu-col ivu-col-span-24"
                                                >
                                                    <div
                                                        class="notice-item-title"
                                                        @click="
                                                            handleTaskModal(
                                                                item,
                                                            )
                                                        "
                                                    >
                                                        <h4>
                                                            {{ item.taskTitle }}
                                                            &nbsp;
                                                            <a>{{
                                                                item.sourceNo
                                                            }}</a>
                                                        </h4>
                                                    </div>
                                                    <div
                                                        class="notice-item-desc flex"
                                                    >
                                                        <span>{{
                                                            item.createdAt
                                                        }}</span>
                                                        <a
                                                            v-if="item.taskFile"
                                                            :href="
                                                                item.taskFile
                                                            "
                                                            class="color-link"
                                                            @click="
                                                                downfile(
                                                                    item.taskFile,
                                                                    $event,
                                                                )
                                                            "
                                                            >{{
                                                                $t(
                                                                    "ucadm.notice.downfile",
                                                                    {
                                                                        defaultValue:
                                                                            "下载文件",
                                                                    },
                                                                )
                                                            }}</a
                                                        >
                                                        <span>{{
                                                            item.status
                                                        }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="notice-footer">
                                    <a :href="getTaskPageUrl" target="_blank">{{
                                        $t("ucadm.notice.readmore", {
                                            defaultValue: "查看更多",
                                        })
                                    }}</a>
                                    <a
                                        v-if="!taskLoading"
                                        @click="getNoticeTaskList"
                                        >{{
                                            $t("global.common.refresh", {
                                                defaultValue: "刷新",
                                            })
                                        }}</a
                                    >
                                    <a v-else class="notice-loading"
                                        ><vIcon
                                            size="18"
                                            type="ios-loading"
                                        ></vIcon>
                                        {{
                                            $t("ucadm.notice.isrefreshing", {
                                                defaultValue: "正在刷新",
                                            })
                                        }}</a
                                    >
                                </div>
                            </TabPane>
                            <TabPane
                                :label="
                                    $t('ucadm.notice.report', {
                                        defaultValue: '报表',
                                    })
                                "
                                name="3"
                            >
                                <div class="notice-list">
                                    <ul class="notice-list-content">
                                        <li
                                            v-for="(
                                                item, index
                                            ) in noticeReportLists"
                                            :key="index"
                                            class="notice-item"
                                        >
                                            <div
                                                class="ivu-row-flex ivu-row-flex-middle"
                                            >
                                                <div
                                                    class="notice-item-content ivu-col ivu-col-span-24"
                                                >
                                                    <div
                                                        class="notice-item-title"
                                                    >
                                                        <h4>
                                                            {{ item.number }}
                                                            <!-- &nbsp;
															<a>{{item.number}}</a> -->
                                                        </h4>
                                                    </div>
                                                    <div
                                                        class="notice-item-desc flex"
                                                    >
                                                        <span>{{
                                                            item.createdAt
                                                        }}</span>
                                                        <a
                                                            v-if="
                                                                item.attachUrl
                                                            "
                                                            :href="
                                                                item.attachUrl
                                                            "
                                                            class="color-link"
                                                            @click="
                                                                downfile(
                                                                    item.attachUrl,
                                                                )
                                                            "
                                                            >{{
                                                                $t(
                                                                    "ucadm.notice.downfile",
                                                                    {
                                                                        defaultValue:
                                                                            "下载文件",
                                                                    },
                                                                )
                                                            }}</a
                                                        >
                                                        <span>{{
                                                            item.status
                                                                | reportStatus
                                                        }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="notice-footer">
                                    <!-- <a :href="getTaskPageUrl" target="_blank">查看更多</a> -->
                                    <a
                                        v-if="!reportLoading"
                                        @click="getNoticeReportList"
                                        >{{
                                            $t("global.common.refresh", {
                                                defaultValue: "刷新",
                                            })
                                        }}</a
                                    >
                                    <a v-else class="notice-loading"
                                        ><vIcon
                                            size="18"
                                            type="ios-loading"
                                        ></vIcon>
                                        {{
                                            $t("ucadm.notice.isrefreshing", {
                                                defaultValue: "正在刷新",
                                            })
                                        }}</a
                                    >
                                </div>
                            </TabPane>
                            <TabPane
                                :label="
                                    $t('ucadm.notice.announcement', {
                                        defaultValue: '公告',
                                    })
                                "
                                name="4"
                            >
                                <div class="notice-list">
                                    <ul class="notice-list-content">
                                        <li
                                            v-for="(
                                                item, index
                                            ) in noticeAnnounceList"
                                            :key="index"
                                            class="notice-item"
                                        >
                                            <div
                                                class="ivu-row-flex ivu-row-flex-middle"
                                            >
                                                <div
                                                    class="notice-item-content ivu-col ivu-col-span-24"
                                                >
                                                    <div
                                                        class="notice-item-title"
                                                        @click="
                                                            handleAnncounceModal(
                                                                item,
                                                            )
                                                        "
                                                    >
                                                        <h4>
                                                            {{ item.title }}
                                                            <!-- &nbsp;
															<a>{{item.number}}</a> -->
                                                        </h4>
                                                    </div>
                                                    <div
                                                        class="notice-item-desc flex"
                                                    >
                                                        <span>{{
                                                            item.brief
                                                        }}</span>
                                                        <!-- <a v-if="item.attachUrl" :href="item.attachUrl" download class="color-link">下载文件</a>
														<span>{{item.status|reportStatus}}</span> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="notice-footer">
                                    <a
                                        href="/home/announce/list"
                                        target="_blank"
                                        >{{
                                            $t("ucadm.notice.readmore", {
                                                defaultValue: "查看更多",
                                            })
                                        }}</a
                                    >
                                    <a
                                        v-if="!announceLoading"
                                        @click="getNoticsAnnounceList"
                                        >{{
                                            $t("global.common.refresh", {
                                                defaultValue: "刷新",
                                            })
                                        }}</a
                                    >
                                    <a v-else class="notice-loading"
                                        ><vIcon
                                            size="18"
                                            type="ios-loading"
                                        ></vIcon>
                                        {{
                                            $t("ucadm.notice.isrefreshing", {
                                                defaultValue: "正在刷新",
                                            })
                                        }}</a
                                    >
                                </div>
                            </TabPane>
                        </Tabs>
                    </div>
                </div>
            </DropdownMenu>
        </Dropdown>
        <!-- 弹框 -->
        <compModal
            v-model="operate.show"
            v-bind="operate"
            @on-close="operate.show = false"
        >
            <component
                v-if="operate.component"
                :is="operate.component"
                v-bind="operate.props"
                @on-close="operate.show = false"
                v-on="operate.on"
            />
        </compModal>
    </aside>
</template>

<script>
// import envhelper from '@nickfan/envhelper'
import * as SockJS from "sockjs-client";
import Stomp from "stompjs";
import * as moment from "moment";
import "moment-timezone";
import * as docTitle from "doc-title";
import { mapMutations } from "vuex";
import {
    HttpNoticeStats,
    HttpRecentNoticeList,
    HttpNoticeTaskList,
    HttpReportList,
    HttpRecentAnnounceList,
    HttpAnnounceStats,
    HttpReadNotice,
} from "../../../../service/notice";
import compDetail from "../../../../views/notice/list/detailmodal";
import compTaskDetail from "../../../../views/notice/task/detailmodal";
import compAnncounceDetail from "../../../../views/notice/announce/detailmodal";
import WebNotification from "../../../../utils/WebNotification";
const checkInterval = 180; // 短检查间隔 3分钟
const checkIntervalLong = 300; // 长检查间隔 5分钟
// 公告轮询间隔
const announceInterval = 60000;
export default {
    components: {
        compDetail,
        compTaskDetail,
        compAnncounceDetail,
    },
    data() {
        return {
            enableIntervalPollingNotice: true, // 是否开启轮询查询
            messageViewModal: false, // 消息查看
            messageViewModalLoading: false, // 消息查看载入中
            originDocTitle: "",
            name: "1",
            noticeType: {
                //通知类型
                1: {
                    title: this.$t("ucadm.notice.announcement", {
                        defaultValue: "公告",
                    }),
                    icon: "star",
                    style: "background-color: rgb(255, 153, 0);",
                },
                2: {
                    title: "提醒",
                    icon: "android-notifications-none",
                    style: "background-color: rgb(254, 92, 87);",
                },
                3: {
                    title: "私信",
                    icon: "ios-email-outline",
                    style: "background-color: rgb(51, 145, 229);",
                },
                4: {
                    title: "群消息",
                    icon: "ios-people-outline",
                    style: "background-color: rgb(240, 98, 146);",
                },
            },
            noticeStatsPullHandle: null,
            noticeRecentLists: {},
            noticeStatsMap: {},
            noticeLastTriggerAtTs: 0, // 最后trigger时间点
            noticeLastCheckAtTs: 0, // 最后check时间点
            noticeLastReceivedAtTs: 0,
            noticeLastReceivedItem: {
                remains: 0,
                lastId: 0,
                lastReceiveAt: 0,
                lastMsgBzevtpId: 0,
                lastMsgTitle: "",
                lastMsgBrief: "",
                lastMsgUrl: "",
                maxReadedId: 0,
            },
            operate: {
                show: false,
            },
            noticeTaskLists: [],
            noticeReportLists: [],
            noticeAnnounceList: [],
            noticeLoading: false,
            taskLoading: false,
            reportLoading: false,
            announceLoading: false,
            announceInterval: null,
            lastAnnounceId: 0,
        };
    },
    watch: {
        // 监听组织变化
        listenOrganization: {
            handler(val) {
                // 重新获取最近公告
                this.getNoticsAnnounceList();
                // 获取最新一条公告
                this.getLastestAnncounce();
            },
        },
    },
    created() {
        this.initWebSocket();
        this.storeEvent({
            name: "pullNoticeStats",
            handler: this.pullNoticeStats,
        });
        this.pollingNotice(false);
        // this.setIntervalPollingNotice(false);
        this.getLastestAnncounce();
        this.pollingAnnounce();
    },
    mounted() {
        this.originDocTitle = document.title;
        docTitle.setApp(this.originDocTitle);
        docTitle.setMessageTime(15000);
    },
    beforeDestroy: function () {
        // 页面离开时断开连接,清除定时器
        this.stompDisconnect();
        if (this.noticeStatsPullHandle) {
            clearInterval(this.noticeStatsPullHandle);
        }
        if (this.announceInterval) {
            clearInterval(this.announceInterval);
        }
        if (this.stompTimer) {
            clearInterval(this.stompTimer);
        }
        this.storeClearEvent('pullNoticeStats');
    },
    filters: {
        reportStatus(val) {
            // 任务状态 0：待运行，1：运行中，2：成功，3：出错
            if (val == 0) return "待运行";
            if (val == 1) return "运行中";
            if (val == 2) return "成功";
            if (val == 3) return "出错";
            if (val == 4) return "超时";
            if (val == 5) return "无数据";
            return val;
        },
    },
    methods: {
        ...mapMutations(["storeEvent", "storeEmit"]),
        async readAllNotice() {
            await HttpReadNotice().then(
                (res) => {
                    this.noticeRecentLists[2].map((item) => {
                        item.notifyReadStatus = 1;
                    });
                    this.$forceUpdate();
                },
                (err) => {
                    this.$VMessage.error(err.message);
                },
            );
        },
        // 点击下载
        downfile(url, event) {
            event.preventDefault();
            this.handleWebfs(url, {}, "download");
        },
        handleNoticeModal(item) {
            const id = item.lastId || item.id;
            this.operate = {
                title: "消息查看",
                show: true,
                width: "large",
                component: "compDetail",
                showFooter: false,
                props: { id },
            };
        },
        //打开任务弹框详情
        handleTaskModal(item) {
            const id = item.lastId || item.id;
            this.operate = {
                title: "任务查看",
                show: true,
                width: 720,
                component: "compTaskDetail",
                showFooter: false,
                props: { id },
            };
        },
        //打开公告弹框详情
        handleAnncounceModal(item) {
            const id = item.lastId || item.id;
            this.operate = {
                title: "公告查看",
                show: true,
                width: "800",
                component: "compAnncounceDetail",
                showFooter: false,
                props: { id, page: 1 },
            };
        },
        getNoticeClasses(item) {
            return [
                "notice-item",
                {
                    "notice-item-unread": item.notifyReadStatus == 0,
                },
            ];
        },
        fixNoticeItemUrl(item) {
            const url = item.lastMsgUrl || item.url;
            const id = item.lastId || item.id;
            if (!url || url.length < 1) {
                return "/home/notice/list/detail?id=" + id;
            }
            return url;
        },
        // 获取最新一条公告
        getLastestAnncounce() {
            HttpAnnounceStats().then((res) => {
                // console.log('最新一条公告', res)
                // 未读，直接展示
                // console.log('是否已读', res.data.stats.marked)
                // 先判断公告创建时间
                // console.log('公告创建时间', res.data.stats.createdAt)
                // UTC时间比较-是否导入的历史数据，历史数据则不展示
                // if (moment(res.data.stats.createdAt).isBefore('2020-07-31 11:19:00')) {
                // 	// return console.log('早于时间点，不显示')
                // 	return
                // }
                // lastId是否和之前一样
                if (this.lastId == res.data.stats.lastId) return;
                // 是否已读
                if (res.data.stats.marked === 0) {
                    this.operate = {
                        title: "公告查看",
                        show: true,
                        width: 720,
                        component: "compAnncounceDetail",
                        showFooter: false,
                        props: { id: res.data.stats.lastId },
                    };
                    this.lastId = res.data.stats.lastId;
                }
            });
        },
        handleNoticeAction(item) {
            item.lastMsgUrl = this.fixNoticeItemUrl(item);
            // console.log('handleNoticeAction', item)
            this.$Notice.info({
                title: item.lastMsgTitle,
                desc: item.lastMsgBrief,
                render: (h) => {
                    return (
                        <a onClick={this.handleNoticeModal.bind(this, item)}>
                            详情
                        </a>
                    );
                    // return h('a', { attrs: { 'href': item.lastMsgUrl, 'target': 'notify' } }, '详情')
                },
                duration: 7,
            });
            docTitle.flash(
                `【${this.getNotifyTotalCount}】条新消息` +
                    " | " +
                    this.originDocTitle,
            );
            let allowNotify = WebNotification.requestPermission();
            if (allowNotify) {
                let mynotify = WebNotification.build(
                    {
                        title: item.lastMsgTitle,
                        body: item.lastMsgBrief,
                    },
                    () => {
                        // console.log('notify clicked')
                        window.location.href = item.lastMsgUrl;
                    },
                );
                // console.log('mynotify', mynotify)
                setTimeout(() => {
                    mynotify.close();
                }, 5000);
            } else {
                // console.log('not allowed')
            }
        },
        processNoticeStats(result) {
            // console.log("enter processNoticeStats");
            try {
                const currentNoticeStatsMap = result.data || {};
                const currentNoticeLastCheckAtTs =
                    result.checkAt === null
                        ? 0
                        : moment.utc(result.checkAt).unix();
                const currentNoticeLastReceivedAtTs =
                    this.calcNoticeLastReceivedAtTs(currentNoticeStatsMap);
                const currentNoticeLastReceivedItem =
                    this.calcNoticeLastReceivedItem(currentNoticeStatsMap);
                const currentNoticeLastReceivedTotalCount =
                    this.calcNoticeTotalCount(currentNoticeStatsMap);

                // console.log('processNoticeStats check handleNoticeAction', currentNoticeLastReceivedItem.lastId, this.noticeLastReceivedItem.lastId)
                let doHandleNoticeAction = false;
                if (
                    currentNoticeLastReceivedTotalCount > 0 &&
                    currentNoticeLastReceivedItem.lastId !== 0 &&
                    this.noticeLastReceivedItem.lastId !=
                        currentNoticeLastReceivedItem.lastId
                ) {
                    doHandleNoticeAction = true;
                    // console.log('processNoticeStats DO handleNoticeAction')
                } else {
                    doHandleNoticeAction = false;
                    // console.log('processNoticeStats NOT handleNoticeAction')
                }
                this.noticeStatsMap = currentNoticeStatsMap;
                this.noticeLastCheckAtTs = currentNoticeLastCheckAtTs;
                this.noticeLastReceivedAtTs = currentNoticeLastReceivedAtTs;
                this.noticeLastReceivedItem = currentNoticeLastReceivedItem;
                if (doHandleNoticeAction) {
                    this.handleNoticeAction(currentNoticeLastReceivedItem);
                }
            } catch (ex) {
                // console.error(ex)
            }
        },
        calcNoticeTotalCount(noticeStatsMap) {
            return Object.values(noticeStatsMap || {}).reduce(
                (total, cur, index, arr) => {
                    return total + parseInt(cur.remains || 0);
                },
                0,
            );
        },
        calcNoticeLastReceivedItem(noticeStatsMap) {
            return Object.values(noticeStatsMap || {}).reduce(
                (lastItem, cur, index, arr) => {
                    const rowLastReceiveAt = cur.lastReceiveAt || null;
                    if (rowLastReceiveAt !== null) {
                        const rowLastReceiveAtTs = moment
                            .utc(rowLastReceiveAt)
                            .unix();
                        if (
                            rowLastReceiveAtTs != 0 &&
                            rowLastReceiveAtTs >= lastItem.lastReceiveAt
                        ) {
                            lastItem = cur;
                        }
                    }
                    return lastItem;
                },
                {
                    remains: 0,
                    lastId: 0,
                    lastReceiveAt: 0,
                    lastMsgBzevtpId: 0,
                    lastMsgTitle: "",
                    lastMsgBrief: "",
                    lastMsgUrl: "",
                    maxReadedId: 0,
                },
            );
        },
        calcNoticeLastReceivedAtTs(noticeStatsMap) {
            return Object.values(noticeStatsMap || {}).reduce(
                (maxTs, cur, index, arr) => {
                    const rowLastReceiveAt = cur.lastReceiveAt || null;
                    if (rowLastReceiveAt !== null) {
                        const rowLastReceiveAtTs = moment
                            .utc(rowLastReceiveAt)
                            .unix();
                        if (
                            rowLastReceiveAtTs != 0 &&
                            rowLastReceiveAtTs > maxTs
                        ) {
                            maxTs = rowLastReceiveAtTs;
                        }
                    }
                    return maxTs;
                },
                0,
            );
        },
        setIntervalPollingNotice(force) {
            // 【关键修复】如果已经有定时器在跑了，先干掉它，防止叠加
            if (this.noticeStatsPullHandle) {
                clearInterval(this.noticeStatsPullHandle);
            }

            if (this.enableIntervalPollingNotice || force) {
                this.noticeStatsPullHandle = setInterval(() => {
                    this.pollingNotice(false);
                }, 1000 * checkInterval);
            }
        },
        //轮询通知
        pollingNotice(force) {
            const currentUtcTs = moment.utc().unix();
            // console.log('pollingNotice', force, currentUtcTs, this.noticeLastTriggerAtTs, this.noticeLastCheckAtTs, (currentUtcTs - this.noticeLastCheckAtTs), (currentUtcTs - this.noticeLastTriggerAtTs))
            if (
                force === true ||
                this.noticeLastTriggerAtTs === 0 ||
                this.noticeLastCheckAtTs === 0 ||
                currentUtcTs - this.noticeLastCheckAtTs >= checkInterval ||
                currentUtcTs - this.noticeLastTriggerAtTs >= checkIntervalLong
            ) {
                // console.log('pollingNotice33333333333333')
                this.noticeLastTriggerAtTs = currentUtcTs;
                this.pullNoticeStats().finally(() => {});
            } else {
                this.noticeLastTriggerAtTs = currentUtcTs;
                // console.log('pollingNotice short')
            }
        },
        // 轮询公告
        pollingAnnounce() {
            this.anncounceInterval = setInterval(() => {
                // 获取最新公告
                this.getLastestAnncounce();
            }, announceInterval);
        },
        stompAuthHeaders() {
            return {
                token: global.AUTH_TOKEN,
            };
        },
        stompConnection() {
            // return Promise.resolve(() => {
            // const wsUrl = this.handleHostname(`https://${global.envPrefix}ucenter.onepinnovate.com/stomp`)
            const wsUrl = `https://${global.envPrefix}ucenter.onepinnovate.com/stomp`;
            // console.log("stompConnection", wsUrl)
            let self = this;
            // 建立连接对象
            this.socket = new SockJS(wsUrl);
            // 获取STOMP子协议的客户端对象
            this.stompClient = Stomp.over(this.socket);
            // 定义客户端的认证信息,按需求配置
            let headers = this.stompAuthHeaders();
            // 向服务器发起websocket连接
            this.stompClient.connect(
                headers,
                (frame) => {
                    // 订阅状态更新
                    try {
                        this.stompClient.send();
                    } catch (error) {}
                    // let notifyCheckStatusRequestJson = JSON.stringify({
                    //     'uid': 0,
                    //     'at': moment.utc().format('YYYY-MM-DD HH:mm:ss')
                    // })
                    //this.stompClient.send('/app/subscribe_notify_stats', {}, notifyCheckStatusRequestJson)
                    this.stompClient.subscribe(
                        "/user/topic/notify_stats",
                        function (message) {
                            // console.log('stompClient notify_stats ', message.body)
                            // self.pollingNotice(true)
                            let restApiResponse = JSON.parse(message.body);
                            self.processNoticeStats(restApiResponse.data || {});
                        },
                    );

                    /*订阅异常消息*/
                    this.stompClient.subscribe(
                        "/user/queue/errors",
                        function (message) {
                            // console.log(message.body)
                        },
                    );

                    //若使用STOMP 1.1 版本，默认开启了心跳检测机制（默认值都是10000ms）
                    this.stompClient.heartbeat.outgoing = 20000;
                    this.stompClient.heartbeat.incoming = 0; //客户端不从服务端接收心跳包
                },
                (err) => {
                    // 连接发生错误时的处理函数
                    // console.log(err)
                     this.setIntervalPollingNotice(true);
                    this.stompReconnect();
                },
            );
            // }).catch(err => {

            // })
        },

        stompReconnect() {
            // 【核心修复】如果已经有一个重连任务在排队，直接忽略本次触发
            if (this.reconnectTimer) return;

            // 【核心修复】设置 5秒 的冷静期，而不是立刻重试
            this.reconnectTimer = setTimeout(() => {
                try {
                    // 只有在确实断开的情况下才尝试重连
                    if (!this.stompClient || !this.stompClient.connected) {
                        console.log("WebSocket 断开，5秒后尝试重连...");
                        this.stompConnection();
                    }
                } catch (e) {
                    console.error("重连失败:", e);
                } finally {
                    // 无论成功失败，释放锁，允许下一次重试
                    this.reconnectTimer = null;
                }
            }, 10000); // 10000毫秒 = 10秒冷却时间
        },
        initWebSocket() {
            this.stompConnection();
            let self = this;
            // 断开重连机制,尝试发送消息,捕获异常发生时重连
            this.stompTimer = setInterval(() => {
                self.stompReconnect();
            }, 5000);
        }, // 断开连接
        stompDisconnect() {
            if (this.stompClient != null) {
                this.stompClient.disconnect();
                // console.log('Disconnected')
            }
        },
        //读取用户通知最近消息
        async getRecentNoticeList() {
            this.noticeLoading = true;
            HttpRecentNoticeList()
                .then((res) => {
                    const data = (res.data || {}).list || {};
                    this.noticeRecentLists = data.data || {};
                })
                .finally(() => {
                    setTimeout(() => {
                        this.noticeLoading = false;
                    }, 1500);
                });
        },
        //主动查询用户通知状态
        async pullNoticeStats() {
            return HttpNoticeStats().then((res) => {
                const data = (res.data || {}).stats || {};
                this.processNoticeStats(data);
            });
        },
        //读取用户任务最近消息
        async getNoticeTaskList(val) {
            this.taskLoading = true;
            HttpNoticeTaskList()
                .then((res) => {
                    const data = res.data || [];
                    this.noticeTaskLists = data;
                })
                .finally(() => {
                    setTimeout(() => {
                        this.taskLoading = false;
                    }, 1500);
                });
        },
        //读取用户报表最近消息
        async getNoticeReportList(val) {
            this.reportLoading = true;
            HttpReportList({
                page: 1,
                rows: 5,
                sidx: "id",
                sord: "desc",
            })
                .then((res) => {
                    const data = (res.data || {}).content;
                    this.noticeReportLists = data || [];
                })
                .finally(() => {
                    setTimeout(() => {
                        this.reportLoading = false;
                    }, 2000);
                });
        },
        // 最近公告
        async getNoticsAnnounceList() {
            this.announceLoading = true;
            HttpRecentAnnounceList()
                .then((res) => {
                    this.noticeAnnounceList = res.data.list || [];
                })
                .finally(() => {
                    setTimeout(() => {
                        this.announceLoading = false;
                    }, 2000);
                });
        },
        getRecentList(val) {
            if (val) {
                this.getRecentNoticeList();
                this.getNoticeTaskList();
                this.getNoticeReportList();
                this.getNoticsAnnounceList();
            }
        },
    },
    computed: {
        // 监听组织是否改变
        listenOrganization() {
            return this.$store.state.organization;
        },
        getAllTotalCount() {
            // 包含通知合计 + 任务合计 + 报表合计
            return this.getNotifyTotalCount; // + this.getTaskTotalCount + this.getReportTotalCount
        },
        getNotifyTotalCount() {
            // 通知合计包括 公告+提醒+私信+群聊
            return this.calcNoticeTotalCount(this.noticeStatsMap);
        },
        // getTaskTotalCount() {
        // 	return 0
        // },
        // getReportTotalCount() {
        // 	return 0
        // },
        getTaskPageUrl() {
            return this.handleHostname(
                `https://${global.envPrefix}boss.onepinnovate.com/home/task/center`,
            );
        },
    },
};
</script>
